import Vue from 'vue';
import Tracker, { VueTracker } from '@bukalapak/tracker-js';
import { getTrackerPlatform } from '~/utils/platform-utils';

const isDev = process.env.NODE_ENV !== 'production' || process.env.WEB_DOMAIN !== 'bukalapak.com';
const devHost = 'https://tracker.preproduction.bukalapak.com';
const prodHost = 'https://t.bukalapak.com';

export default (ctx, inject) => {

  Tracker.config({
    baseUrl: isDev ? devHost : prodHost,
    dev: isDev || process.env.DEV_DEBUG_TRACKER,
    platform: getTrackerPlatform(),
  });

  // Inject tracker instance as $tracker
  ctx.$tracker = Tracker;
  inject('tracker', Tracker);

  // Register plugin
  Vue.use(VueTracker);
};
